import {VENDORS_URL} from '../constants';
import vendorList from './list';
import {logger} from '../services/logger';

const ERROR_RESPONSE = 'Vendor list - invalid response.';
const ERROR_FETCH = 'Vendor list - fetch error.';

/**
 * Adds urls and names to ourVendors list.
 * @param {Array} allVendors
 * @param {Array} ourVendors
 */
const mergeVendors = (allVendors, ourVendors) =>
  ourVendors.map(vendor => {
    const relevantVendor = allVendors.find(v => v.id === vendor.id);

    return relevantVendor && relevantVendor.name && relevantVendor.policyUrl ? {...vendor, ...relevantVendor} : vendor;
  });

/**
 * Sets vendor values to ConsentString.
 * @param {ConsentString} consentData
 * @param {Array} vendors
 */
export const setVendorsToConsent = (consentData, vendors) => {
  vendors.map(vendor => {
    consentData.setVendorAllowed(vendor.id, vendor.checked);
  });
};

/**
 * Returns vendor list where all allowed vendors from Profil data have checked: true.
 * @param {Object} data
 */
export const getPreFilledVendors = data => {
  if (data && data.euconsent && data.euconsent.allowedVendorIds) {
    return vendorList.vendors.map(vendor => ({
      ...vendor,
      checked: data.euconsent.allowedVendorIds.indexOf(vendor.id) !== -1
    }));
  }

  return vendorList.vendors;
};

/**
 * Returns vendor list where all allowed vendors from Profil data have checked: true.
 * @param {Object} data
 */
export const getPreFilledVendorsFromCookie = data =>
  vendorList.vendors.map(vendor => ({
    ...vendor,
    checked: data.indexOf(vendor.id) !== -1
  }));

let vendorListPromise = null;

/**
 * Returns Promise with vendors.
 * @return {Promise}
 */
export const getVendors = () => vendorListPromise;

/**
 * GVL (global vendor list) is necessary for CMP. Because we cannot create euconsent cookie without it.
 * But also we want to open dialog as soon as possible and we don't want to wait for GVL download.
 * So GVL will be  downloaded on background.
 */
export const loadVendors = () => {
  logger(2000, 'Starting download GVL.');
  vendorListPromise = new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open('GET', VENDORS_URL, true);

    xhr.onload = () => {
      if (xhr.status === 200) {
        try {
          const data = JSON.parse(xhr.response);
          logger(2001, 'Vendor list downloaded:', data);
          resolve(data);
        } catch (error) {
          reject(ERROR_RESPONSE);
        }
      } else {
        reject(ERROR_RESPONSE);
      }
    };

    xhr.onerror = () => {
      reject(ERROR_FETCH);
    };

    xhr.send();
  });
};

/**
 * Gets list of all vendors from external service and add current urls/names to ourVendors.
 * @param {Array} ourVendors
 * @return {Promise}
 */
export const getVendorsWithUrls = ourVendors =>
  new Promise(async (resolve, reject) => {
    try {
      const data = await getVendors();
      const vendorsWithUrls = mergeVendors(data.vendors, ourVendors);

      logger(2002, 'The current url and names have been added to vendor list:', vendorsWithUrls);
      resolve(vendorsWithUrls);
    } catch (error) {
      reject(ERROR_RESPONSE);
    }
  });
